import React from 'react';
import { LineChart, LinePlot, MarkPlot } from '@mui/x-charts/LineChart';
import {
    BarPlot,
    ChartsLegend,
    ChartsTooltip,
    ChartsXAxis,
    ChartsYAxis,
    ResponsiveChartContainer,
} from '@mui/x-charts';
import { HistoryItemType, SummaryType } from '../../../common/commonTypes';
import { COLORS } from '../../../common/colors';
import { useTranslation } from 'react-i18next';

type HistoryChartType = {
    groupedMeals: HistoryItemType;
};

const HistoryChart = (props: HistoryChartType) => {
    const { groupedMeals } = props;

    const { t, i18n } = useTranslation();

    const chartData = [
        {
            type: 'bar',
            key: 'calories',
            label: t('calories'),
            color: COLORS.caloriesLight,
            transform: (value: number) => value / 10,
        },
        {
            type: 'line',
            key: 'protein',
            label: t('protein'),
            color: COLORS.protein,
        },
        { type: 'line', key: 'fats', label: t('fat'), color: COLORS.fat },
        {
            type: 'line',
            key: 'carbsNoSugars',
            label: t('carbs'),
            color: COLORS.carb,
        },
        { type: 'line', key: 'sugars', label: t('sugar'), color: COLORS.sugar },
    ].map(({ key, label, color, transform }) => {
        const data = Object.values(groupedMeals)
            .map((item) =>
                transform
                    ? transform(item.totals[key as keyof SummaryType])
                    : item.totals[key as keyof SummaryType]
            )
            .reverse();

        return { data, label, color };
    });

    const xLabels = Object.values(groupedMeals)
        .map((item) => ({
            label: item.misc.dayForChart, // e.g., "04/09"
            display: `${item.misc.dayForChart}\n${item.misc.weekday}`, // e.g., "04/09\nTue"
            isWeekend: item.misc.isWeekend,
        }))
        .reverse();

    const CaloriesBarData = chartData.find((chart) => chart.label === t('calories'));
    const LineChartsData = chartData.filter((chart) => chart.label !== t('calories'));

    return (
        <>
            <div className="p-2">
                <div className="w-full" style={{ height: '200px' }}>
                    <ResponsiveChartContainer
                        series={[
                            {
                                type: 'bar',
                                data: CaloriesBarData?.data || [],
                                color: CaloriesBarData?.color,
                                label: CaloriesBarData?.label,
                                // @ts-ignore
                                valueFormatter: (v) => v * 10,
                            },
                            // @ts-ignore
                            ...LineChartsData.map(({ data, label, color }) => ({
                                type: 'line',
                                data,
                                label,
                                color,
                            })),
                        ]}
                        xAxis={[
                            {
                                data: xLabels.map((x) => x.label),
                                scaleType: 'band',
                                id: 'x-axis-id',
                                valueFormatter: (value) => {
                                    const labelData = xLabels.find((x) => x.label === value);
                                    if (!labelData) return value;
                                    const { display, isWeekend } = labelData;
                                    return display;
                                },
                            },
                        ]}
                        // yAxis={[
                        //        {
                        //            scaleType: 'linear',
                        //            id: 'macrosAxis', // ID for line chart values
                        //        },
                        //        {
                        //            scaleType: 'band',
                        //            id: 'calAxis', // ID for bar chart values
                        //        },
                        //     ]}
                        margin={{
                            left: 0,
                            right: 0,
                            top: 20,
                            bottom: 40,
                        }}
                    >
                        <BarPlot />
                        <LinePlot />
                        {/*<MarkPlot />*/}
                        <ChartsTooltip />
                        <ChartsLegend
                            labelStyle={{ fontSize: 12 }}
                            itemMarkWidth={15}
                            itemMarkHeight={15}
                        />
                        <ChartsXAxis position="bottom" axisId="x-axis-id" />
                        {/*<ChartsYAxis position="left" axisId="macrosAxis" />*/}
                        {/*<ChartsYAxis position="right" axisId="calAxis" />*/}
                    </ResponsiveChartContainer>
                </div>
            </div>
        </>
    );
};

export default HistoryChart;
